import DeviceManager from '../utils/device-manager';
import { createPopper } from '@popperjs/core';

const TimelineCarousel = {
    $swipers: [],
    swipers: {},
    poppers: {},

    init() {
        this.$swipers = document.querySelectorAll('.timeline_horizontale .swiper');

        window.process = {
            env: {
                NODE_ENV: 'production'
            }
        }

        this.$swipers.forEach(($swiper, index) => {
            this.initSwiper($swiper, index);
        });

    },

    showTooltip (tooltipId) {
        const popper = this.poppers[tooltipId];

        this.closeAllTooltips();

        popper.tooltip.setAttribute('data-show', '');
        popper.tooltip.classList.add('show');
        popper.popperInstance.update();
        popper.btnMore.closest('.swiper-slide').classList.add('tooltip-open');
    },

    hideTooltip (tooltipId) {
        const popper = this.poppers[tooltipId];

        popper.tooltip.removeAttribute('data-show', '');
        popper.tooltip.classList.remove('show');
        popper.btnMore.closest('.swiper-slide').classList.remove('tooltip-open');
    },

    toggleTooltip (tooltipId) {
        const popper = this.poppers[tooltipId];

        if (popper.tooltip.hasAttribute('data-show')) {
            this.hideTooltip(tooltipId);
        } else  {
            this.showTooltip(tooltipId);
        }
    },

    closeAllTooltips () {
        for (const id in this.poppers) {
            this.hideTooltip(id);
        }
    },

    initSwiper($swiper, name) {
        const $slides = $swiper.querySelectorAll('.swiper-slide');

        let args = {
            updateOnWindowResize: true,
            slidesPerView: 1,
            loop: false,
            allowTouchMove: true,
            threshold: 10,
            spaceBetween: 20,
            autoHeight: false,
            navigation: {
                prevEl: '.custom-button-prev',
                nextEl: '.custom-button-next',
            },
            pagination: $slides.length > 1 ? {
                el: '.swiper-pagination',
                clickable: true,
            } : false,
            breakpoints: {},
            on: {
                resize: function () {
                    if(this.navigation.$nextEl[0].getAttribute('aria-disabled') === 'true' && this.navigation.$prevEl[0].getAttribute('aria-disabled') === 'true') {
                        this.navigation.$nextEl[0].classList.add('hidden');
                        this.navigation.$prevEl[0].classList.add('hidden');
                    } else {
                        this.navigation.$nextEl[0].classList.remove('hidden');
                        this.navigation.$prevEl[0].classList.remove('hidden');
                    }
                }
            }
        };
        // custom-button-nav

        args.breakpoints[DeviceManager.devices.lg] = {
            slidesPerView: 3.5,
            spaceBetween: 20,
        };

        args.breakpoints[DeviceManager.devices.md] = {
            slidesPerView: 2.5,
            spaceBetween: 20,
        };

        this.swipers[name] = new Swiper($swiper, args);

        function updateHeight () {
            var h3Height = 0;
            $slides.forEach(function (item) {
                h3Height = Math.max(h3Height, item.querySelector('h3').offsetHeight);
            });

            $slides.forEach(function (item) {
                item.querySelector('h3').style.height = h3Height + 'px';
            });
        }

        setTimeout(() => {
            $slides.forEach(($slide, index) => {
                const $btnMore = $slide.querySelector('.en-savoir-plus_wrapper .toggle');
                const $tooltip = $slide.querySelector('.en-savoir-plus_tooltip');

                if($btnMore) {
                    const id = $btnMore.getAttribute('data-popper-name');
                    const popperInstance = createPopper($btnMore, $tooltip, {
                        placement: 'top',
                        modifiers: [
                            {
                                name: 'offset',
                                options: {
                                    offset: [0, -25],
                                },
                            },
                        ],
                    });

                    this.poppers[id] = {
                        btnMore: $btnMore,
                        tooltip: $tooltip,
                        popperInstance: popperInstance
                    }

                    $btnMore.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.showTooltip(event.currentTarget.getAttribute('data-popper-name'));
                    })
                }
            })
        }, 500);


        document.addEventListener('click', (event) => {
            if( !event.target.hasAttribute('data-popper-name') ) {
                const $closest = event.target.closest('.en-savoir-plus_tooltip');
                if ($closest) {
                    // console.log($closest);
                    const $btnClose = event.target.closest('.close-info');
                    if ($btnClose || event.target.classList.contains('.close-info')) {
                        this.closeAllTooltips()
                    }
                } else {
                    this.closeAllTooltips();
                }
;            }
        })

        setTimeout(function () {
            var evt = document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
            window.dispatchEvent(new Event('resize'));

            updateHeight();

            window.addEventListener("resize", function () {
                updateHeight();
            });
        }, 2000);
    }
}

export default TimelineCarousel;